import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function AdminLogin({ onLogin }) {
  const [form, setForm] = useState({ name: '', password: '' });
  const navigate = useNavigate();

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('https://shophub-server.vercel.app/api/auth/admin/login', form);
      localStorage.setItem('token', res.data.token);
      alert('Login successful!');
      navigate('/add-product'); // Navigate to add-product page
    } catch (err) {
      alert('Login failed: ' + (err.response?.data?.message || err.message));
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 p-4 max-w-sm mx-auto">
      <input
        name="name"
        placeholder="Admin name"
        onChange={handleChange}
        className="w-full border p-2 rounded"
      />
      <input
        name="password"
        type="password"
        placeholder="Password"
        onChange={handleChange}
        className="w-full border p-2 rounded"
      />
      <button type="submit" className="bg-black text-white px-4 py-2 rounded">Login</button>
    </form>
  );
}
